<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view>
      <meta http-equiv="refresh" content="20" />
    </router-view>
  </div>
</template>

<script>
export default {
    name: 'app',
}
</script>

<style>
</style>
